export const isGlobalLocale = (locale) => 'label' in locale;
export const isRegularLocale = (locale) => 'flag' in locale;
